/* eslint-disable no-use-before-define */

// import { stringify } from 'postcss-scss';

// var _ = require('lodash');
const dropDownInstances = require('./dropdown-instances');

export const jobVacanciesSearch = () => {
    // var perfEntries = performance.getEntriesByType('navigation');

    // if (perfEntries && perfEntries.length > 0) {
    //     var type = perfEntries[0].type;

    //     // This is necessary to enable deselecting filters
    //     // after accessing the page using the back button
    //     if (type === 'back_forward') {
    //         location.reload();
    //     }
    // }

    let skipLoading = false;

    let currentSearchResultState;

    $('#job-vacancy-search-button').on('click', (e) => {
        e.preventDefault();
        ajaxCall();
    });

    $('#vacancy-search-form').on('submit', (e) => {
        e.preventDefault();
        ajaxCall();
    });

    $('.js-styled-select-vakgebieden').on('change', function () {
        if (!skipLoading) {
            ajaxCall(false, $(this));
        }
    });

    $('.js-styled-select-functiegroepen').on('change', function () {
        if (!skipLoading) {
            ajaxCall(false, $(this));
        }
    });

    $('.js-styled-select-opleidingen').on('change', function () {
        if (!skipLoading) {
            ajaxCall(false, $(this));
        }
    });

    $('.js-styled-select-uren').on('change', function () {
        if (!skipLoading) {
            ajaxCall(false, $(this));
        }
    });

    $('.js-styled-select-contractvormen').on('change', function () {
        if (!skipLoading) {
            ajaxCall(false, $(this));
        }
    });

    $('.js-styled-select-nieuw').on('change', function () {
        if (!skipLoading) {
            ajaxCall(false, $(this));
        }
    });

    $(document).on('click', '#resetFiltersButton', () => {
        ajaxCall(true);
    });

    const vacancyHolder = document.querySelector('#vacancy-holder');
    const isNewVacancyLabel = vacancyHolder?.dataset?.isnewvacancylabel;

    if (vacancyHolder) {
        ajaxCall();
    }

    function ajaxCall(resetFilters, triggerButton) {
        const jobquery = $('#vacancy-search-input').val();

        let useOrHiddenInput = $('input#use-or');
        let useOr = useOrHiddenInput.val();

        let sections = '';
        let functiongroups = '';
        let educations = '';
        let hours = '';
        let contracttypes = '';
        let newonly = '';

        if (!resetFilters) {
            sections = getFilters(
                dropDownInstances.jobVacancyVakgebiedenButton
            );
            functiongroups = getFilters(
                dropDownInstances.jobVacancyFunctieGroepenButton
            );
            educations = getFilters(
                dropDownInstances.jobVacancyOpleidingenButton
            );
            hours = getFilters(dropDownInstances.jobVacancyUrenButton);
            contracttypes = getFilters(
                dropDownInstances.jobVacancyContractVormenButton
            );
            newonly = getFilters(dropDownInstances.jobVacancyNieuwButton);
        }

        const culture = document.documentElement.lang;

        $.ajax({
            url: '/api/jobvacancies',
            type: 'GET',
            dataType: 'json',
            data: {
                jobquery,
                sections,
                functiongroups,
                educations,
                hours,
                contracttypes,
                newonly,
                culture,
                useOr,
            },
            success(result) {
                currentSearchResultState = result;

                let queryString = '';

                if (jobquery) {
                    if (culture === 'nl') {
                        queryString += `&jobquery=${encodeURIComponent(
                            jobquery
                        )}`;
                    } else {
                        queryString += `&jobquery=${encodeURIComponent(
                            jobquery
                        )}`;
                    }
                }

                if (sections) {
                    if (culture === 'nl') {
                        queryString += `&vakgroep=${encodeURIComponent(
                            sections
                        )}`;
                    } else {
                        queryString += `&section=${encodeURIComponent(
                            sections
                        )}`;
                    }
                }

                if (functiongroups) {
                    if (culture === 'nl') {
                        queryString += `&functiegroep=${encodeURIComponent(
                            functiongroups
                        )}`;
                    } else {
                        queryString += `&functiongroup=${encodeURIComponent(
                            functiongroups
                        )}`;
                    }
                }

                if (educations) {
                    if (culture === 'nl') {
                        queryString += `&opleiding=${encodeURIComponent(
                            educations
                        )}`;
                    } else {
                        queryString += `&education=${encodeURIComponent(
                            educations
                        )}`;
                    }
                }

                if (hours) {
                    if (culture === 'nl') {
                        queryString += `&uren=${encodeURIComponent(hours)}`;
                    } else {
                        queryString += `&hours=${encodeURIComponent(hours)}`;
                    }
                }

                if (contracttypes) {
                    if (culture === 'nl') {
                        queryString += `&contractvormen=${encodeURIComponent(
                            contracttypes
                        )}`;
                    } else {
                        queryString += `&contracttypes=${encodeURIComponent(
                            contracttypes
                        )}`;
                    }
                }

                if (newonly) {
                    if (culture === 'nl') {
                        queryString += `&newonly=${encodeURIComponent(
                            newonly
                        )}`;
                    } else {
                        queryString += `&newonly=${encodeURIComponent(
                            newonly
                        )}`;
                    }
                }

                if (useOr) {
                    queryString += `&useor=true`;
                }

                if (queryString) {
                    queryString = `?${queryString.substring(1)}`;
                }

                window.history.replaceState(
                    '',
                    '',
                    window.location.pathname + queryString
                );

                if (
                    result.DidYouMeanResult &&
                    result.DidYouMeanResult.Hits.length > 0
                ) {
                    const didYouMeanHtml = generateDidYouMeanHtml(
                        result.DidYouMeanResult
                    );
                    $('#vacancy-holder').html(didYouMeanHtml);
                } else {
                    const html = generateVacancyHtml(result);

                    $('#vacancy-holder').html(html);
                }

                $('.intro-text-filters').html(result.TotalResultsText);

                showActiveFilters(
                    sections,
                    functiongroups,
                    educations,
                    hours,
                    contracttypes,
                    newonly
                );

                skipLoading = true;
                reloadFilterButtons(
                    triggerButton,
                    sections,
                    functiongroups,
                    educations,
                    hours,
                    contracttypes,
                    newonly,
                    result
                );
                skipLoading = false;

                $('#vacancy-search-buttons-holder').removeClass('hidden');

                $(() => {
                    $('#vacancy-holder a').on('click', function () {
                        // console.log('tracking');
                        $.get('/clicktracking/track', {
                            jobquery,
                            hitId: $(this).data('hitid'),
                            trackId: result.TrackId,
                        });
                    });
                });
            },
        });
    }

    function getFilters(selectField) {
        if (!selectField) {
            return null;
        }

        if (selectField.selection.size === 0) {
            return '';
        }

        let filters = [];

        filters = Array.from(selectField.selection.keys());

        return decodeURI(filters.join());
    }

    function reloadFilterButtons(
        triggerButton,
        sections,
        functiongroups,
        educations,
        hours,
        contracttypes,
        newonly,
        apiCallResult
    ) {
        skipLoading = true;

        const { jobVacancyVakgebiedenButton } = dropDownInstances;
        reloadButton(
            jobVacancyVakgebiedenButton,
            currentSearchResultState.SectionsFacet,
            triggerButton,
            sections,
            apiCallResult.SectionsCaption
        );

        const { jobVacancyFunctieGroepenButton } = dropDownInstances;
        reloadButton(
            jobVacancyFunctieGroepenButton,
            currentSearchResultState.FunctionGroupsFacet,
            triggerButton,
            functiongroups,
            apiCallResult.FunctionGroupsCaption
        );

        const { jobVacancyOpleidingenButton } = dropDownInstances;
        reloadButton(
            jobVacancyOpleidingenButton,
            currentSearchResultState.EducationFacet,
            triggerButton,
            educations,
            apiCallResult.EducationLevelsCaption
        );

        const { jobVacancyUrenButton } = dropDownInstances;
        reloadButton(
            jobVacancyUrenButton,
            currentSearchResultState.HoursFacet,
            triggerButton,
            hours,
            apiCallResult.HoursCaption
        );

        const { jobVacancyContractVormenButton } = dropDownInstances;
        reloadButton(
            jobVacancyContractVormenButton,
            currentSearchResultState.ContractTypeFacet,
            triggerButton,
            contracttypes,
            apiCallResult.ContractTypesCaption
        );

        const { jobVacancyNieuwButton } = dropDownInstances;
        reloadButton(
            jobVacancyNieuwButton,
            currentSearchResultState.NewOnlyFacet,
            triggerButton,
            newonly,
            apiCallResult.NewOnlyCaption
        );

        skipLoading = true;
    }

    function reloadButton(
        selectButton,
        facet,
        triggerButton,
        selectedItems,
        caption
    ) {
        // selectedItems can be a comma-delimited list.

        // console.log(selectButton.settings.id);
        // console.log($(triggerButton).attr('name'));

        let isTriggerButton = false;

        if (selectButton.settings.id === $(triggerButton).attr('name')) {
            isTriggerButton = true;
        }

        let selectItemsArray;

        if (selectedItems) {
            selectItemsArray = selectedItems.split(',');
        } else {
            selectButton.selection.clear();
        }

        if (!isTriggerButton || !selectItemsArray) {
            while (selectButton.select.options.length > 0) {
                selectButton.select.remove(0);
            }
        }

        if (!facet) {
            return;
        }

        facet.forEach((term) => {
            let skipTerm = false;

            if (term.Term) {
                if (isTriggerButton) {
                    Array.from(selectButton.select.options).forEach((option) => {
                        if (option.label === term.Term) {
                                skipTerm = true;
                            }
                        }
                    );
                }

                if (skipTerm === false) {
                    const newOption = new Option(term.Term, term.Term);
                    if (
                        selectItemsArray &&
                        selectItemsArray.includes(term.Term)
                    ) {
                        newOption.selected = true;
                    }
                    selectButton.select.add(newOption, undefined);
                }
            }
        });

        selectButton.title.innerHTML = caption;

        // eslint-disable-next-line no-param-reassign
        selectButton.list.innerHTML = '';
        selectButton.createListItems();
    }

    function showActiveFilters(
        sections,
        functiongroups,
        educations,
        hours,
        contracttypes,
        newonly
    ) {
        let html = ' ';

        if (
            sections ||
            functiongroups ||
            educations ||
            hours ||
            contracttypes ||
            newonly
        ) {
            html += '<p>Filters: </p>';
        }

        html += '<ul>';

        if (sections) {
            const list = sections.split(',');

            list.forEach((element) => {
                html += `<li>${decodeURIComponent(element)}</li>`;
            });
        }

        if (functiongroups) {
            const list = functiongroups.split(',');

            list.forEach((element) => {
                html += `<li>${decodeURIComponent(element)}</li>`;
            });
        }

        if (educations) {
            const list = educations.split(',');

            list.forEach((element) => {
                html += `<li>${decodeURIComponent(element)}</li>`;
            });
        }

        if (hours) {
            const list = hours.split(',');

            list.forEach((element) => {
                html += `<li>${decodeURIComponent(element)}</li>`;
            });
        }

        if (contracttypes) {
            const list = contracttypes.split(',');

            list.forEach((element) => {
                html += `<li>${decodeURIComponent(element)}</li>`;
            });
        }

        if (newonly) {
            //list.forEach((element) => {
            html += `<li>${decodeURIComponent(newonly)}</li>`;
            //});
        }

        html += '</ul>';

        if (
            sections ||
            functiongroups ||
            educations ||
            hours ||
            contracttypes ||
            newonly
        ) {
            html +=
                "<p><button id='resetFiltersButton'>Reset filters</button></p>";
        }

        $('#vacancy-filter-feedback').html(html);
    }

    function generateDidYouMeanHtml(didYouMeanResult) {
        let html = 'Bedoelde u ';

        $.each(didYouMeanResult.Hits, (i, hit) => {
            html += `
                <div>
                    <a href="?jobquery=${hit.Suggestion}">
                        ${hit.Suggestion} ?
                    </a>
                </div>`;
        });

        return html;
    }

    function generateVacancyHtml(searchResult) {
        let html = '';

        $.each(searchResult.SearchResultItems, (i, searchResultItem) => {
            html += `
                <div class="vacancy-preview-holder background-tint--sky--transparent">
                    <a href="${searchResultItem.Url}" data-hitid="${searchResultItem.HitType}/${searchResultItem.HitId}">
                        <h3>${searchResultItem.Title}${searchResultItem.InternalVacancy}</h3>
                        <div class="tags-outer-holder">`;
            if (searchResultItem.IsNewVacancy) {
                html += `
                    <div>
                        <div class="tag-new-vacancy"></div>
                        <p>${isNewVacancyLabel}</p>
                    </div>`;
            }

            let searchResultHours = searchResultItem.Hours;

            if (searchResultHours) {
                searchResultHours = `${searchResultHours} ${searchResult.HoursText}`;
            }

            html += `
                            <div>
                                <p>${searchResultItem.SalaryText || ''}</p>
                            </div>
                            <div>
                                <p>${searchResultHours || ''}</p>
                            </div>
                            <div>
                                <p>${searchResultItem.Education || ''}</p>
                            </div>
                            <div>
                                <p>${searchResultItem.ContractType || ''}</p>
                            </div>
                            <div>
                                <p>${
                                    searchResultItem.NumberOfDaysToClosingOfVacancyText ||
                                    ''
                                }</p>
                            </div>
                        </div>
                        <div>
                            ${searchResultItem.Description || ''}
                        </div>
                    </a>
                </div>`;
        });

        return html;
    }
};
